module.exports = __webpack_public_path__ + "static/media/css.621f21fa.png";